// extracted by mini-css-extract-plugin
export default {"question":"FAQ_question__eHBtN","questionItem":"FAQ_questionItem__IN3V6","questionTitle":"FAQ_questionTitle__-6L5S"};